import { render, staticRenderFns } from "./chatBoxesLight.vue?vue&type=template&id=7a0e7e5d&"
var script = {}
import style0 from "./chatBoxesLight.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports